<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (sortObject)="getSortItems($event)"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
>
  <!-- custom header -->
  <app-page-header
    custom-header
    [title]="pageConfig.title"
    [loading]="pageConfig.loading"
    [showAuditBtn]="pageConfig?.showAuditBtn"
    [showHelpBtn]="pageConfig?.showHelpBtn"
    (onAdd)="onCreate()"
    (onShowAudit)="onShowAuditPage()"
    (onShowHelp)="onShowHelpPage()"
  >
  </app-page-header>

  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- reseller -->
        <td>
          <td-value
            class="tw-font-medium"
            copyToClipboard
            [value]="item?.userName"
          ></td-value>
        </td>

        <!-- times -->
        <td>
          <span>
            {{ item?.times | enumToText : ResellerTargetTimesEnumValues }}</span
          >
        </td>
        <!-- targetValue -->
        <td>
          <td-value
            type="number"
            copyToClipboard
            [value]="item?.targetValue"
          ></td-value>
        </td>

        <!-- credit -->
        <td>
          <span
            copyToClipboard
            [class]="fontSize == 'sm' ? 'tw-text-[11px]' : 'tw-text-[12px]'"
            [credit]="item?.credit"
            >{{ item?.credit | numberSeparator | checkValue }}</span
          >
        </td>

        <!-- created -->
        <td>
          <td-value type="dateTime" [value]="item?.created"></td-value>
        </td>

        <!------------------------------- operations -------------------------------->

        <td class="sticky-td">
          <app-table-operations
            [model]="item"
            (onDelete)="onDelete($event.id, $event.nameFa)"
            (onUpdate)="onUpdate($event.id)"
          >
          </app-table-operations>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!-- add or update form -->
<ng-container *ngIf="pageConfig?.isVisibleForm">
  <app-resellers-target-form
    [formPageConfig]="formPageConfig"
    (closeFormPage)="getFormResponse($event)"
  >
  </app-resellers-target-form>
</ng-container>

<!--------------------------------------------------------------- Audit ---------------->
<ng-container *ngIf="pageConfig?.isVisibleAuditPage">
  <app-audit
    [service]="currentService"
    [methodName]="auditApiMethodName"
    (hidePage)="onHideAuditPage()"
  >
  </app-audit>
</ng-container>

<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    menuTitle="ResellerTarget"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
